import axios from 'axios';

import { logError } from '../../infrastructure/error-handling.js';

class PartnersService {
	getPartnersDetailsPage(lang) {
		return axios
			.get(
				`${
					process.env.REACT_APP_API_ENDPOINT
				}/api/singletons/get/PartnersDetails?lang=${lang}`,
			)
			.then(({ data }) => data)
			.catch(logError);
	}

	applyPartner(data, file) {
		const formData = new FormData();
		formData.set('form[name]', data.name);
		formData.set('form[email]', data.email);
		formData.set('form[phone]', data.phone);
		formData.set('form[nationality]', data.nationality);
		formData.set('formfiles[resume]', file);
		formData.set(
			'form[furtherInformationProposal]',
			data.furtherInformationProposal,
		);
		formData.set(
			'form[furtherInformationYourself]',
			data.furtherInformationYourself,
		);

		return axios
			.post(
				`${
					process.env.REACT_APP_API_ENDPOINT
				}/api/forms/submit/ApplyPartner?token=${
					process.env.REACT_APP_API_TOKEN
				}`,
				formData,
				{
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				},
			)
			.then(res => res)
			.catch(logError);
	}
}

export default new PartnersService();
